import { Core } from "@/core/Core";


export default {

  /** Loyalty Transactions **/
  async getLoyaltyTransaction(context, id) {
    try {
      return await Core.request("GET", "/api/loyalty_transactions/" + id);
    } catch (e) {
      return new Core.Error(e);
    }
  },

  /** Loyalty Accounts **/
  async getLoyaltyAccount(context, id) {
    try {
      return await Core.request("GET", "/api/loyalty_accounts/" + id + "?augment=customers");
    } catch (e) {
      return new Core.Error(e);
    }
  },

  async putLoyaltyAccount(context, {id, data}) {
    try {
      return await Core.request("PUT", "/api/loyalty_accounts/" + id  + "?augment=customers", data);
    } catch (e) {
      return new Core.Error(e);
    }
  },

  async postLoyaltyAccountAdjustment(context, {id, data}) {
    try {
      return await Core.request("POST", `/api/loyalty_accounts/${id}/adjust`, data);
    } catch (e) {
      return new Core.Error(e);
    }
  },

  /* Gift cards */
  async getGiftCard(context, number) {
    try {
      let response = await Core.request("GET", `/api/gift_cards?number=${number}`);
      if (response.data) {
        return response.data[0];
      }
    } catch (e) {
      return new Core.Error(e);
    }
  },


  async getGiftCardTransactions(context, {branchId, number}) {  /* cardId or number fields */
    try {
      let response = await Core.request("GET", `/api/gift_card_transactions?branch=${branchId}&number=${number}`);
      if (response.data) {
        return response.data;
      }
      return [];
    } catch (e) {
      return new Core.Error(e);
    }
  },

  async giftCardAdjustment(context, {cardId, amount, reason}) {
    try {
      let response = await Core.request("PUT", `/api/gift_cards/${cardId}/adjust`, {
        amount: amount,
        moreData: {
          reason: reason
        }
      });
      if (response) {
        return response;
      }
      return [];
    } catch (e) {
      return new Core.Error(e);
    }
  },

  async createGiftCard(context, data) {
    try {
      let response = await Core.request("POST", "/api/gift_cards", data);
      if (response) {
        return response;
      }
      return [];
    } catch (e) {
      return null;
    }
  },

  async loadGiftCardTemplates(context, branchId) {
    try {
      let response = await Core.request("GET", `/api/gift_card_templates?branch=${branchId}`);
      if (response) {
        return response;
      }
    } catch (e) {
      return [];
    }
  },
}
